import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = { class: "header_R" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<section class=\"main\"><div class=\"item\"><div class=\"item_L\">1</div><div class=\"item_R\">2</div></div><div class=\"item\"><div class=\"item_L\">1</div><div class=\"item_R\">2</div></div><div class=\"item\"><div class=\"item_L\">1</div><div class=\"item_R\">2</div></div></section>", 1)

import {onMounted,reactive} from 'vue';
import { useRouter } from 'vue-router'
import nbaApi from "@/api/nbaApi";
import { Dialog } from 'vant';

// const route = useRoute();

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "558bdb18": (_ctx.color)
}))

const router = useRouter();

let DATA = reactive({
  userData: {}
});

onMounted(() => {
  init();
});


function init(){
  getUsersInfoData();
}

async function getUsersInfoData() {
  const ret = await nbaApi.getUsersInfo();
  console.log(222,ret);
  if(ret.code !== 0){
    console.log(111);
    Dialog.confirm({
      title: '提示',
      message: ret.message,
    })
        .then(() => {
          sessionStorage.setItem('token','');
          router.push('/login')
        })
        .catch((err) => {
          console.log(err);
        });
  }
  DATA.userData = ret.data;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(DATA).userData)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", {
            class: "header_L backgroundImage",
            style: _normalizeStyle({backgroundImage:`url(${_unref(DATA).userData.userLogo})`})
          }, null, 4),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(DATA).userData.userName), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_4
  ], 64))
}
}

})